import { FC } from 'react'
import { Wishlist } from '@pylot-data/pylotschema'
import { useTranslation } from 'next-i18next/pages'

export type Props = {
    wishlist: Wishlist
}

export const WishlistCount: FC<Props> = ({ wishlist }) => {
    const { t } = useTranslation(['wishlist'])

    if (!wishlist?.items_count) return null
    const count = wishlist!.items_count!

    return (
        <span>
            {count} {count > 1 ? t('wishlist|items') : t('wishlist|item')}
        </span>
    )
}
